export const type = 'form.modalRowList';
